// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emailHome[data-v-2d346fb3]{padding:15px 0 0 0;width:100%}", ""]);
// Exports
module.exports = exports;
